import { useState } from 'react';

import { CustomModal, PillButton } from '../../../../../components/custom';
import BulkApproveTransactions from './BulkApproveTransactions';
import BulkDeclineTransactions from './BulkDeclineTransactions';

interface IBulkApprovalActionsProps {
  selectedTransactions: (string | number)[];
  handleResetSelectedTransactions: () => void;
}

export default function BulkApprovalActions({
  selectedTransactions,
  handleResetSelectedTransactions,
}: IBulkApprovalActionsProps) {
  const [isApproveModalOpen, setIsApproveModalOpen] = useState(false);
  const [isDeclineModalOpen, setIsDeclineModalOpen] = useState(false);

  return (
    <>
      <>
        <PillButton
          background="#FAE8EC"
          color="#CC1440"
          sx={{
            padding: '4px 16px',
            height: '32px',
            width: '92px',
          }}
          onClick={() => setIsDeclineModalOpen(true)}
        >
          {selectedTransactions.length === 1 ? 'Decline' : 'Decline All'}
        </PillButton>
        <PillButton
          background="#14CC52"
          color="#fff"
          sx={{
            padding: '4px 16px',
            height: '32px',
            width: '92px',
          }}
          onClick={() => setIsApproveModalOpen(true)}
        >
          {selectedTransactions.length === 1 ? 'Approve' : 'Approve All'}
        </PillButton>
      </>
      <>
        <CustomModal
          isOpen={isDeclineModalOpen}
          onClose={() => setIsDeclineModalOpen(false)}
        >
          <BulkDeclineTransactions
            selectedTransactions={selectedTransactions}
            handleResetSelectedTransactions={handleResetSelectedTransactions}
          />
        </CustomModal>

        <CustomModal
          isOpen={isApproveModalOpen}
          onClose={() => setIsApproveModalOpen(false)}
        >
          <BulkApproveTransactions
            selectedTransactions={selectedTransactions}
            handleResetSelectedTransactions={handleResetSelectedTransactions}
          />
        </CustomModal>
      </>
    </>
  );
}
